// extracted by mini-css-extract-plugin
export default {"container":"ErrorBoundaryFallbakc_container__awf5w","content":"ErrorBoundaryFallbakc_content__EAu-r","title":"ErrorBoundaryFallbakc_title__b0jNo"};